import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-left-3-icon',
  templateUrl: './navigation-left-3.component.html'
})
export class NavigationLeft3Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
